export default {
  TITLE: 'TITLE',
  BODY: 'BODY',
  ID: 'ID',
  URL: 'URL',
};



// WEBPACK FOOTER //
// ./src/views/mainSearch/SearchBy.js